<template>
  <header class="main-header">
    <div class="headerinner">
      <h1 class="logo">
        <router-link to="/" class="logolink"><img src="../assets/img/cmn/scopelogo02.svg" alt="SALES SCOPE" class="logoimg"></router-link>
        <a href="/" class="logolinkss"><img src="../assets/img/cmn/pb-sslogo02.svg" alt="powered by SALES SCORE" class="logoimg"></a>
      </h1>
    </div>
  </header>
</template>


<script>
export default {
  data() {
    return {
      scrollY: window.pageYOffset,
      navlocate: 0,
      navLock: false,
    };
  },
  computed: {
    glovalNavClass: function () {
      return {
        "global-nav": true,
        "-lock": this.navLock,
      };
    },
  },
  methods: {
    handleScroll: function () {
      this.scrollY = window.pageYOffset;
      // console.log(this.scrollY);
      if (this.scrollY >= this.navlocate.top) {
        this.navLock = true;
      } else {
        this.navLock = false;
      }
    }
  },
  mounted: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  animation: menu-fade 0.3s;
}
.fade-leave-active {
  animation: menu-fade 0.1s reverse;
}
@keyframes menu-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>